import { Injectable } from '@angular/core';
import { CustomizationModel } from './model/customization.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CustomizationService {

  constructor(private http: HttpClient) { }

  getCustomizationList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/customization/get', requestData);

  }

  getMenuDepartments(): Observable<any> {
    return this.http.post(environment.baseUrl+'/menu/menu-departments','');

  }

   getSaleItems(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/sale-item/get', requestData);

  }

   getSaleItemById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/sale-item/get/'+id, '');

  }

  getCustomizationById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/customization/get/'+id, '');

  }

   /**
   * 
   * @param reasonsInfo 
   * Calls the update API to insert/update the record
   */
   update(reasonsInfo: CustomizationModel): Observable<any> { 
    if(reasonsInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/customization/update', reasonsInfo);
    } else{
      return this.http.post(environment.baseUrl+'/customization/add', reasonsInfo);
    }
  }


    /**
   * 
   * @param menuInfo 
   * Calls the API to delete the record
   */
    delete(menuInfo: CustomizationModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/customization/delete/'+menuInfo.id, menuInfo);
    }

    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(environment.baseUrl + '/customization/export', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }

}
